export default __webpack_public_path__ + "static/media/eRx_Normal.5bb4c120.svg";